import { ErrorWithStatus, HttpStatus } from './error-with-status';

/**
 * Implementation of mandatory errors expected to get returned by a gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte */
export class InvalidParameterError extends ErrorWithStatus {
  constructor(message?: string) {
    super('InvalidParameterError', HttpStatus.BadRequest, message ?? 'invalid request body');
  }
}

/**
 * Implementation of mandatory errors expected to get returned by a gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte */
export class CannotGetAllowedUsersForModeAllowAllError extends ErrorWithStatus {
  constructor() {
    super(
      'CannotGetAllowedUsersForModeAllowAllError',
      HttpStatus.Forbidden,
      'cannot get allowed users for mode AllowAll'
    );
  }
}

/**
 * Implementation of mandatory errors expected to get returned by a gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte */
export class CannotAddAllowedUsersInAllowAllModeError extends ErrorWithStatus {
  constructor() {
    super(
      'CannotAddAllowedUsersInAllowAllModeError',
      HttpStatus.Forbidden,
      'cannot add allowed users in AllowAll mode'
    );
  }
}

/**
 * Implementation of mandatory errors expected to get returned by a gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte */
export class CannotDeleteAllowedUsersInAllowAllModeError extends ErrorWithStatus {
  constructor() {
    super(
      'CannotDeleteAllowedUsersInAllowAllModeError',
      HttpStatus.Forbidden,
      'cannot delete allowed users in AllowAll mode'
    );
  }
}

/**
 * Implementation of mandatory errors expected to get returned by a gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte */
export class CannotGetBlockedUsersForModeBlockAllError extends ErrorWithStatus {
  constructor() {
    super(
      'CannotGetBlockedUsersForModeBlockAllError',
      HttpStatus.Forbidden,
      'cannot get blocked users for mode BlockAll'
    );
  }
}

/**
 * Implementation of mandatory errors expected to get returned by a gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte */
export class CannotAddBlockedUsersInBlockAllModeError extends ErrorWithStatus {
  constructor() {
    super(
      'CannotAddBlockedUsersInBlockAllModeError',
      HttpStatus.Forbidden,
      'cannot add blocked users in BlockAll mode'
    );
  }
}

/**
 * Implementation of mandatory errors expected to get returned by a gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte */
export class CannotDeleteBlockedUsersInBlockAllModeError extends ErrorWithStatus {
  constructor() {
    super(
      'CannotDeleteBlockedUsersInBlockAllModeError',
      HttpStatus.Forbidden,
      'cannot delete blocked users in BlockAll mode'
    );
  }
}
